export default __webpack_public_path__ + "static/media/電表.755ee7ec.gif";